import { render, staticRenderFns } from "./ClientCreatePage.vue?vue&type=template&id=da531328"
import script from "./ClientCreatePage.vue?vue&type=script&lang=js"
export * from "./ClientCreatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports